<template>
    <div class="dashboard-container">
        <div class="dashboard-top">
            <div class="total-dashboard-list">
                <div class="total-dashboard-item" v-if="manage">
                    <el-card class="box-card">
                        <div class="box-card-content">
                            <div class="dashboard-icon">
                                <i class="el-icon-money fs20 text-white"></i>
                            </div>
                            <div class="dashboard-text">
                                <div class="dashboard-text-val">¥{{availableMoney}} </div>
                                <div class="dashboard-text-title">总用户余额</div>
                            </div>
                        </div>
                    </el-card>
                </div>
                <div class="total-dashboard-item">
                    <AmountCard :dataObj = "verificationAndCardStatsData.verification_amount" title="核销金额"></AmountCard>                 
                </div>
                <div class="total-dashboard-item">
                    <AmountCard :dataObj = "verificationAndCardStatsData.card_amount" title="提卡金额"></AmountCard>
                </div>  
                <div class="total-dashboard-item">
                    <AmountCard :dataObj = "verificationAndCardStatsData.locked_card_amount" title="锁卡金额"></AmountCard>
                </div>
                <div class="total-dashboard-item">
                    <AmountCard :dataObj = "verificationAndCardStatsData.unverified_card_amount" title="未核销金额"></AmountCard>
                </div>
            </div>            
        </div>	
        <div class="query-box">
            <el-card class="query-card">
                <div class="query-card-title">
                    <div class="flexX flexcenter gap10">
                        <div class="query-item flexX flexcenter">
                            <div class="query-item-label c606266 fs14">产品名称：</div>
                            <div class="query-item-content">
                                <el-select v-model="formQuery.product_code" @change="getData" size="small" placeholder="请选择" clearable >
                                    <el-option
                                    v-for="item in options.products"
                                    :key="item.product_code"
                                    :label="item.product_name"
                                    :value="item.product_code">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="query-item flexX flexcenter">
                            <span class="query-item-label c606266 fs14"> 时间：</span>
                            <el-date-picker class="query-date" size="small" v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>

                        </div>
                    </div>
                    <div class="query-card-btn">
                        <el-button type="primary" size="small" @click = "getData">查询</el-button>
                        <el-button type="plain" size="small" @click="reset">重置</el-button>
                    </div>
                </div>
            </el-card>
        </div>
        <div class="dashboard-data-box">
            <el-card class="dashboard-card ">
                <div class="flexX flexcenter flexBetween">
                    <div class="card-title c303133 fw6 fs16">今日产品数据统计</div>
                    <div class="card-content flexX flexcenter">
                            <el-button  type="primary" size="small" class="query-btn" @click="exportData">导出数据</el-button>
                            <el-button  type="plain" size="small" class="query-btn" @click="getData">刷新</el-button>
                    </div>
                </div>
                <div class="table-box">
                    <el-table class="table-class"  :data="tableData" style="width: 100%;" header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                        <el-table-column prop="product_name" label="产品名称" ></el-table-column>
                        
                        <el-table-column label="面值" width="240px" align="center">
                            <template slot-scope="scope">
                                <div class="face-value-list">
                                    ¥{{ scope.row.value }}                               
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="今日核销金额" width="240px" align="center">
                            <template slot-scope="scope">
                                <div class="face-value-list">
                                    ¥{{  scope.row.verification_amount }}                               
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="今日提卡金额" width="240px" align="center">
                            <template slot-scope="scope">
                                <div class="face-value-list">
                                    ¥{{  scope.row.card_amount   }}                               
                                </div>
                            </template>
                        </el-table-column>
                        
                    </el-table>
                    <div class="flexX pageBox flexEnd">
                        <el-pagination :disabled="dashboardData.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formQuery.page" :page-sizes="dashboardData.pageSizesArr"
                            :page-size="formQuery.size" layout="total, sizes, prev, pager, next" :total="dashboardData.total"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
   
</template>
<script>
	import {
		Message
	} from 'element-ui'
    import AmountCard from '@/components/dashboard/amountCard.vue'
    import axios from 'axios'
    export default {
        components: {
            AmountCard
        },
        data() {
            let manage = this.$local.get('manage')
			return {
                date:[],
                report:{},
                availableMoney:'0.00',
                verificationAndCardStatsData:{},
                tableData:[],
                formQuery:{
                    product_code:'',
                    page:1,
                    size:10,
                },
                dashboardData:{
                    pageSizesArr:[10,50,200,500],
                    loading:false,
                    total:0,

                },
                options:{
                    products:[]
                },                
				manage:manage
            };
        },
        created() {
            this.date = [this.$util.timestampToTime(new Date().getTime(),true), this.$util.timestampToTime(new Date().getTime(),true)]
            if(this.manage){
                // 管理元才能调用查看总余额
                this.reportAll()
            }
            
            this.verificationAndCardStats();
            this.getData();

		},
        methods: {
            // 获取数据
            reportAll(){   
                this.$api.reportAll({status:'all'}).then(res => {
                    if(res.status == 1){
                        this.report = res.data
                        this.availableMoney = this.setMoneyFormat(res.data.total_available_money)
                    }else{
                        Message({
                            message: res.msg,
                            type: 'error',
                            duration: 3 * 1000
                        });
                    }
                }).catch(err => {
                    console.log(err)
                })
                
            },
            setMoneyFormat(val){
                let money = val.toFixed(2);
                let moneyArr = money.toString().split('.');
                if(moneyArr[0].length > 3){ 
                    money = moneyArr[0].replace(/\B(?=(\d{3})+$)/g, ',');
                }else{
                    money = moneyArr[0];
                }
                console.log(money,'=+++=')
                if(moneyArr[1]){ 
                    money += '.' + moneyArr[1];
                }
                console.log(money,'===')
                return money
            },
            //核销总金额  提卡金额 获取
            verificationAndCardStats(){
                this.$api.verificationAndCardStats({}).then(res=>{
                    if(res.status == 1){ 
                        this.verificationAndCardStatsData = res.data
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            getData(){
                this.formQuery.page = 1;
                this.productDataStats()
            },
            reset(){
                this.formQuery.product_code='';
                this.formQuery.page=1;
                this.getData();
            },
            //获取指定产品的统计数据
            productDataStats(){
                this.formQuery.start_time = this.date && this.date.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.date[0])), true) : ''
                this.formQuery.end_time=this.date && this.date.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.date[1])), true) : ''                 
                this.$api.productDataStats(this.formQuery).then(res=>{
                    if(res.status == 1){ 
                        this.tableData = res.data.list.data
                        this.options.products = res.data.products
                        this.dashboardData.total = res.data.list.total
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
              // 分页查询数据
              handleSizeChange(val){
                this.formQuery.size = val;
                this.formQuery.page = 1
                this.dashboardData.total = 0
                this.productDataStats()
            },
            handleCurrentChange(val){
                this.formQuery.page = val
                this.productDataStats()
            },
            //导出数据
            exportData(){
                let start_time = this.date && this.date.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.date[0])), true) : ''
                let end_time = this.date && this.date.length == 2 ? this.$util.timestampToTime(Date.parse(new Date(this.date[1])), true) : '' 
                let product_code = this.formQuery.product_code
                window.open(this.$baseURL+'/report/exportProductDataStats'+'?username='+this.$local.get('username')+'&tid='+this.$local.get('tid'))+'&start_time='+start_time+'&end_time='+end_time+'&product_code='+product_code
                
            }
            
        }
    }
</script>
<style lang="scss" scoped>
    .dashboard-container{
        display: flex;
        flex-direction: column;
        gap: 32px;
        .dashboard-top{
            // padding-top: 22px;       
             
        }
        .total-dashboard-list{
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            // gap: 16px;
            .total-dashboard-item{
              width: 547px;
              padding: 0 8px;
              .box-card{

                height:140px;
                .box-card-content{
                        display: flex;
                        .dashboard-icon{
                            width: 44px;
                            height: 44px;
                            background-color: #409eff;
                            border-radius: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                        }
                        .dashboard-text{
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            margin-left: 32px;
                            .dashboard-text-val{
                                font-size: 24px;
                                font-weight: 600;
                                color: #303133;
                                line-height: 1.2;
                            }
                            .dashboard-text-title{
                                font-size: 13px;
                                color: #606266;
                                margin-top: 4px;
                            }

                        }
                }
               }
            }
        }
        .query-box{
            padding:8px;
            .query-card-title{
                display: flex;
                justify-content: space-between;
            }
        }    
        .dashboard-data-box{
            .table-box{
                margin-top: 31px;
                margin-left:10px;
                .face-value-list{
                    display: flex;
                    flex-wrap: wrap;
                    gap: 4px;
                    justify-content: center
                }
                .table-operation{
                    margin-right: 10px;
                }
            .pageBox{
                padding: 16px 20px;
                border-top: 1px solid #ebeef5;
                background-color: #fafcff;
                // position:absolute;  
                // bottom: 50PX;
                // right: 30px;

            }
            .delete-btn{
                &:hover{
                    color:#fab6b6,
                }
                &:focus{
                    color:#fab6b6,
                }
            }
            }
        
        }
    }
.total-dashboard-item {
    flex: 0 0 100%;
    max-width: 100%;
}
@media only screen and (min-width: 768px) {
    .total-dashboard-item {
        display: block;
        flex: 0 0 50%;
        max-width: 50%;
    }
}
@media only screen and (min-width: 1200px) {
    .total-dashboard-item {
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
    }
}
</style>